import React from 'react';
import { View } from '@uncinc/react-drupal-core';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

const ParagraphNewsOverviewHighlighted = ({ entity }) => {
  const title = entity.getIn(['field_title', 0, 'value']);
  const linkTitle = entity.getIn(['field_link', 0, 'title']);
  const linkUri = entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri']));

  return (
    <div className="Paragraph ParagraphNewsOverviewHighlighted">
      <Container>
        <div className="ParagraphNewsOverviewHighlighted__content">
          {title && <h2>{title}</h2>}
        </div>
        <View id="articles" display="promoted" linkUri={linkUri} linkTitle={linkTitle} />
      </Container>
    </div>
  );
};

export default ParagraphNewsOverviewHighlighted;
